<template>
  <div class="blob-container">
    <div class="svg-container">
      <div
        v-for="index in 5"
        :class="'img-container cont-' + index"
        :key="index"
      >
        <img
          :class="'test img-' + index"
          :src="'/pet_images/' + imageIndex[index - 1] + '.png'"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
// WE HAVE 13 IMAGES
let imagesNum = 13;

export default {
  name: "Blobs",
  mounted() {
    for (let index = 0; index < 5; index++) {
      let imageID = 0;
      do {
        imageID = Math.floor(Math.random() * imagesNum) + 1;
        // console.log(`Random num 14: ${imageID}`);
      } while (this.imageIndex.includes(imageID));
      this.imageIndex.push(imageID);
    }
    // console.log("The array: ", this.imageIndex);
  },
  data() {
    return {
      imageIndex: [],
    };
  },
};
</script>

<style scoped>
.blob-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vmax;
  z-index: -2;
  overflow: hidden;
  opacity: 1 !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: visible;

  height: 100%;
}

.svg-container {
  width: 100%;
  height: 100%;
  opacity: 0.5 !important;
}

.test {
  position: absolute;
  top: 0;
  left: 0%;
  height: 100%;
  /* filter: blur(5px); */
}

.img-container {
  aspect-ratio: 1;
  position: absolute;
  border-radius: 50%;
  /* left: -5%; */
  box-shadow: var(--box-shadow-focus);
  filter: blur(5px);
  filter: blur(2px);
  min-width: 20rem;
  width: 100%;
  max-width: 50rem;
}

.cont-1 {
  /* right: 40%;
  top: -10%; */
  right: 40vw;
  top: -10vh;
  width: 70%;
  max-width: 60rem;
}

.cont-2 {
  /* left: 50%;
  top: -10%; */
  left: 50vw;
  top: -10vh;
  width: 50%;
}
.cont-3 {
  /* left: 25%; */
  /* top: 35%;
  right: -10%; */
  top: 35vh;
  right: -10vw;
  width: 50%;
}
.cont-4 {
  /* left: 5%;
  top: 55%; */
  left: 5vw;
  top: 55vh;
  width: 35%;
}
.cont-5 {
  /* right: -20%;
  top: 80%; */
  right: -20vw;
  top: 80vh;
  width: 80%;
}
.cont-6 {
  left: 60%;
  top: -10%;
  width: 50%;
}
.cont-7 {
  left: 60%;
  top: -10%;
  width: 50%;
}
.cont-8 {
  left: 60%;
  top: -10%;
  width: 50%;
}

.cont-3,
.cont-4 {
  max-width: 30rem;
}
/* .cont-5, */
.cont-6,
.cont-7,
.cont-8 {
  display: none;
}

@media screen and (max-width: 54rem) {
  .cont-1 {
    top: 0;
    width: 80%;
    right: 30%;
  }
  .cont-2 {
    top: 30%;
  }

  .cont-3 {
    top: 50%;
    right: 50%;
  }

  .cont-4 {
    top: 70%;
    left: 50%;
  }

  .cont-5 {
    top: 90%;
    right: 10%;
    width: 150%;
  }
}

@media screen and (min-width: 54rem) {
  .cont-3 {
    top: 50%;
    right: calc(50% + 10rem);
  }

  .cont-4 {
    top: 70%;
    left: calc(50% + 10rem);
  }

  .cont-5 {
    top: 80%;
    left: 10%;
    width: 150%;
  }
}
</style>
